<template>
  <span class="clickable" @click="handleClick">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "MuiLink",
  props: {
    to: {
      type: String,
      default: "/",
    },
  },
  methods: {
    handleClick() {
      this.$router.push(this.to);
    },
  },
};
</script>

<style lang="scss" scoped></style>
